import { render, staticRenderFns } from "./answer-box.vue?vue&type=template&id=5fbb0ede&scoped=true"
import script from "./answer-box.vue?vue&type=script&lang=js"
export * from "./answer-box.vue?vue&type=script&lang=js"
import style0 from "./answer-box.vue?vue&type=style&index=0&id=5fbb0ede&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb0ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbb0ede')) {
      api.createRecord('5fbb0ede', component.options)
    } else {
      api.reload('5fbb0ede', component.options)
    }
    module.hot.accept("./answer-box.vue?vue&type=template&id=5fbb0ede&scoped=true", function () {
      api.rerender('5fbb0ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/answer-box.vue"
export default component.exports